import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle } from 'lucide-react';
import { BookCallButton } from './BookCallButton';
import { images, TRAILER_EMBED_URL } from '../../data/foundingProgram';
export function FoundingHero() {
  return <section className="relative overflow-hidden border-b border-[#D4AF37]/15 bg-[#08070A]" data-id="element-1385" data-mp="4j8ryotdtmis">
      <img src={images.hero} alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.15]" data-id="element-1386" data-mp="9cl25txbdqs0" />
      <div className="absolute inset-0 bg-[#08070A]/85" aria-hidden="true" data-id="element-1387" data-mp="ianeh5mi05ul" />

      <div className="relative mx-auto grid min-h-[84vh] w-full max-w-7xl items-center gap-12 px-5 py-16 sm:px-8 lg:grid-cols-[0.88fr_1.12fr] lg:gap-16 lg:py-24" data-id="element-1388" data-mp="narqaicgoceh">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-1389" data-mp="2p2ed07pbll55">
          <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1390" data-mp="2u3lmcb742sdx">
            Founding Membership is open
          </p>
          <h1 className="mt-6 font-serif text-5xl leading-[1.02] text-[#FDFBF7] sm:text-6xl lg:text-7xl" data-id="element-1391" data-mp="72mzkmr6ljt">
            Don&rsquo;t just learn Sikh history.
            <span className="mt-2 block text-[#D4AF37]" data-id="element-1392" data-mp="3rbavoq351h39">Step inside it.</span>
          </h1>
          <p className="mt-7 max-w-xl text-lg font-light leading-relaxed text-[#FDFBF7]/75" data-id="element-1393" data-mp="3mchhswjxvo2k">
            Sikh Kingdoms brings the people, places and defining moments of the
            Sikh Empire to life through immersive storytelling.
          </p>
          <div className="mt-9" data-id="element-1394" data-mp="dxzef84y0wpa">
            <BookCallButton size="lg" data-id="element-1395" data-mp="dwxra5ankjr7" />
          </div>
          <p className="mt-4 text-sm font-light text-[#FDFBF7]/50" data-id="element-1396" data-mp="9xoz34v9gtxr">
            A relaxed 20-minute conversation. No obligation.
          </p>
          <a href="#vision" className="mt-7 inline-block text-[11px] uppercase tracking-[0.22em] text-[#FDFBF7]/45 underline-offset-4 transition-colors duration-150 ease-out hover:text-[#D4AF37] hover:underline" data-id="element-1397" data-mp="2yqb01ikpqtz5">
            Discover the vision
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-1398" data-mp="311k59pj5wb8o">
          <p className="mb-4 flex items-center gap-2 text-[10px] uppercase tracking-[0.28em] text-[#D4AF37]" data-id="element-1399" data-mp="2ddsjzwfn8nv9">
            <PlayCircle className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1400" data-mp="2i5u3o3f55gvb" />
            Watch the trailer
          </p>
          <div className="relative aspect-video w-full overflow-hidden border border-[#D4AF37]/30 bg-black shadow-[0_24px_70px_rgba(0,0,0,0.5)]" data-id="element-1401" data-mp="23h7c93c8oynq">
            <iframe src={TRAILER_EMBED_URL} title="Sikh Kingdoms experience trailer" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 h-full w-full" data-id="element-1402" data-mp="1uf6hqe8e4qpr" />
          </div>
        </motion.div>
      </div>
    </section>;
}